import * as React from "react";
import {Link} from "react-router-dom";
import {resourcesHelper} from "@falcon/services";

export class NoActivePolicyBanner extends React.Component {

    public render() {
        return (
            <div id="noActivePolicyBanner" className="banner">
                <img src={`/${resourcesHelper.THEME}/img/alert-red.svg`} alt="Red alert icon"/>
                <div className="banner-text">
                    There is no active policy in your {resourcesHelper.THEME}. Check your old policies or, why not, {' '}
                    <Link to="/dashboard/viewOrGetQuotes" id="viewOrGetQuotes">
                        get a new quote
                    </Link>
                </div>
            </div>
        );
    }
}
